import { render, staticRenderFns } from "./EditPlannedPrivateLessonCard.vue?vue&type=template&id=ad8912d4&scoped=true&"
import script from "./EditPlannedPrivateLessonCard.vue?vue&type=script&lang=js&"
export * from "./EditPlannedPrivateLessonCard.vue?vue&type=script&lang=js&"
import style0 from "./EditPlannedPrivateLessonCard.vue?vue&type=style&index=0&id=ad8912d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8912d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
